import { PageMeta } from '@/@vxapp/@Enums/PageMeta'

const SITE_PAGES_ROUTE = {
  LIST: PageMeta.Sites.List.Name,
}

export default [
  { heading: 'Sites' },
  {
    page: PageMeta.Sites.List,
    title: PageMeta.Sites.List.Title,
    icon: { icon: PageMeta.Sites.List.Icon },
    to: SITE_PAGES_ROUTE.LIST,
  },
]
